import { TranslateService } from '@ngx-translate/core';
import { Injectable } from '@angular/core';

@Injectable()
export class TicketDurationDescriptionService {

    constructor(private translate: TranslateService) {}

    getProductDurationDescription(activeTicketDurationInMinutes: number) {
        if (!activeTicketDurationInMinutes) return;

        const tickedDurationInHours = Math.floor(activeTicketDurationInMinutes / 60);
        const remainingMinutes = activeTicketDurationInMinutes % 60;

        if (tickedDurationInHours === 1) {
            return this.assembleDurationTranslation(
                'ACTIVATED_TICKET_VALID_HOUR',
                tickedDurationInHours,
                remainingMinutes
            );
        }
        if (tickedDurationInHours > 1) {
            return this.assembleDurationTranslation(
                'ACTIVATED_TICKET_VALID_HOURS',
                tickedDurationInHours,
                remainingMinutes
            );
        }
    }

    private assembleDurationTranslation(
        instantKey: string,
        tickedDurationInHours: number,
        remainingMinutes: number
    ): string {
        let translation: string;
        translation = this.translate.instant(instantKey);
        translation = translation.replace('{{hours}}', tickedDurationInHours.toString());
        if (remainingMinutes === 0) return translation;

        const minutesTranslation = this.translate
                                       .instant('AND_MINUTES')
                                       .replace('{{minutes}}', remainingMinutes.toString());
        return `${translation} ${minutesTranslation}`;
    }
}
